export default "__VITE_ASSET__874bd939__"